import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Schools from "./components/Schools";
// import Add from "./components/Add";
// import Update from "./components/Update";
import Home from "./components/Home";
import Header from "./components/Header";
import Rankings from "./components/Rankings";
import WWNTeam from "./components/WWNTeam";
import backgroundImage from "./images/wwn_background_body.png";
import leftSidebarImage from "./images/wwn_left_sidebar_v2.png";
import rightSidebarImage from "./images/wwn_right_sidebar_v2.png";
import "./styles/global_style.css"

function App() {
  return (
    <div className="App" style={{backgroundImage: `url(${backgroundImage})`,}}>
      {/* sidebar left  */}
      <div className="entire_body">
        <div id="sidebar_left" class="sidebars">
          <img src={leftSidebarImage} alt="Left Sidebar" id="sidebar_left_image" className="sidebar_images"/>
        </div>
        <div id="inner_body">
          {/* body  */}
          {/* inner body (middle of 3 columns) */}
          <div>
            {/* header component */}
            <BrowserRouter>
              <Header/> 
              <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path="/rankings/:genderId" element={<Rankings/>}/>
                <Route path="/rankings/:genderId/:classificationId/:weightId" element={<Rankings/>}/>
                <Route path="/wwnteam" element={<WWNTeam/>}/>
                {/* <Route path="/" element={<Schools/>}/> */}
                {/* <Route path="/add" element={<Add/>}/>
                <Route path="/update/:id" element={<Update/>}/> */}
              </Routes>
            </BrowserRouter>
          </div>
        </div>
        <div id="sidebar_right" class="sidebars">
            <img src={rightSidebarImage} alt="Right Sidebar" id="sidebar_right_image" className="sidebar_images"/>
        </div>
      </div>  
    </div>
  );
}

export default App;
